import React from 'react';
import HomePageSEOSetting from 'src/components/Modules-revamp/SlugSeoSetting';
import ContentCarouselRender from 'src/constrains/SalesChannelContent-Revamp/Modules/ContentCarousel';
import ContentGridRender from 'src/constrains/SalesChannelContent-Revamp/Modules/ContentGrid';
import IframeRender from 'src/constrains/SalesChannelContent-Revamp/Modules/Iframe';
import ImageCarouselRender from 'src/constrains/SalesChannelContent-Revamp/Modules/ImageCarousel';
import {
  pageSetting,
  seoSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage-revamp/constants';

import ErrSection from '@/src/components/Modules-revamp/ErrorSection';
import Visible from '@/src/components/Modules-revamp/Visible';
import { Field, Form } from '@/src/components/RcForm';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import PageSetting from 'src/components/Modules-revamp/PageSettings';
import ContentTabRender from 'src/constrains/SalesChannelContent-Revamp/Modules/ContentTab';
import PosterRender from 'src/constrains/SalesChannelContent-Revamp/Modules/Poster';
import PosterTabRender from 'src/constrains/SalesChannelContent-Revamp/Modules/PosterTab';
import ProductCarouselRender from 'src/constrains/SalesChannelContent-Revamp/Modules/ProductCarousel';
import ProductGridRender from 'src/constrains/SalesChannelContent-Revamp/Modules/ProductGrid';
import ProductTabRender from 'src/constrains/SalesChannelContent-Revamp/Modules/ProductTab';
import SubscriptionRender from 'src/constrains/SalesChannelContent-Revamp/Modules/Subscription';
import TextRender from 'src/constrains/SalesChannelContent-Revamp/Modules/Text';
import { EnumModuleType } from 'src/types/common/module';

const moduleRender = (type: EnumModuleType, props: any) => {
  switch (type) {
    case EnumModuleType.ResponsiveImageCarousel: {
      return <ImageCarouselRender {...props} />;
    }
    case EnumModuleType.ResponsiveProductCarousel: {
      return <ProductCarouselRender {...props} />;
    }
    case EnumModuleType.ResponsiveContentCarousel: {
      return <ContentCarouselRender {...props} />;
    }
    case EnumModuleType.ResponsivePoster: {
      return <PosterRender {...props} />;
    }
    case EnumModuleType.ResponsiveText: {
      return <TextRender {...props} />;
    }
    case EnumModuleType.ResponsiveSubscription: {
      return <SubscriptionRender {...props} />;
    }
    case EnumModuleType.ResponsiveProductGrid: {
      return <ProductGridRender {...props} />;
    }
    case EnumModuleType.ResponsiveContentGrid: {
      return <ContentGridRender {...props} />;
    }
    case EnumModuleType.ResponsivePosterTab: {
      return <PosterTabRender {...props} />;
    }
    case EnumModuleType.ResponsiveProductTab: {
      return <ProductTabRender {...props} />;
    }
    case EnumModuleType.ResponsiveContentTab: {
      return <ContentTabRender {...props} />;
    }
    case EnumModuleType.ResponsiveIframe: {
      return <IframeRender {...props} />;
    }
  }
};

const ModuleRender = ({ form, breakpoint, ...extra }) => {
  return (
    <Field name={'moduleType'}>
      {(props, meta, { getFieldValue }) => {
        const moduleType = getFieldValue('moduleType');
        return <>{moduleRender(moduleType, { form, breakpoint, ...extra })}</>;
      }}
    </Field>
  );
};

const contentRender = ({
  pcForm,
  mobileForm,
  tabletForm,
  seoSettingForm,
  pageSettingForm,
  selectedItem,
  handlePCFormValuesChange,
  handleOnSectionReset,
  handleOnSectionCopy,
  pageSettingConfigData,
  seoSettingConfigData,
  isOnPrimaryLanguage,
  salesChannelMode,
  disabled,
}) => {
  if (selectedItem === seoSetting) {
    return [
      {
        child: (
          <Form form={seoSettingForm}>
            <HomePageSEOSetting
              isPrimary={isOnPrimaryLanguage}
              {...seoSettingConfigData}
              disabled={disabled}
            />
          </Form>
        ),
        key: seoSetting,
      },
    ];
  }
  if (selectedItem === pageSetting) {
    return [
      {
        child: (
          <Form form={pageSettingForm}>
            <PageSetting
              isPrimary
              {...(pageSettingConfigData || {})}
              disabled={disabled}
            />
          </Form>
        ),
        key: pageSetting,
      },
    ];
  }

  const commonProps = {
    handleOnSectionReset,
    handleOnSectionCopy,
    salesChannelMode,
    disabled,
  };

  return [
    {
      child: (
        <Form
          form={pcForm}
          onValuesChange={(...p) => {
            handlePCFormValuesChange(...p);
          }}>
          <Visible
            breakpoint={EPreviewSize.WIDE}
            translateDisabled={disabled}
          />
          <ErrSection breakpoint={EPreviewSize.WIDE} form={pcForm} />
          <ModuleRender
            form={pcForm}
            breakpoint={EPreviewSize.WIDE}
            {...commonProps}
          />
        </Form>
      ),
    },
    {
      child: (
        <Form
          form={tabletForm}
          onValuesChange={(p) => {
            return;
          }}>
          <Visible
            breakpoint={EPreviewSize.TABLET}
            translateDisabled={disabled}
          />
          <ErrSection breakpoint={EPreviewSize.TABLET} form={tabletForm} />
          <ModuleRender
            form={tabletForm}
            breakpoint={EPreviewSize.TABLET}
            {...commonProps}
          />
        </Form>
      ),
    },
    {
      child: (
        <Form
          form={mobileForm}
          onValuesChange={(p) => {
            return;
          }}>
          <Visible
            breakpoint={EPreviewSize.MOBILE}
            translateDisabled={disabled}
          />
          <ErrSection breakpoint={EPreviewSize.MOBILE} form={mobileForm} />
          <ModuleRender
            form={mobileForm}
            breakpoint={EPreviewSize.MOBILE}
            {...commonProps}
          />
        </Form>
      ),
    },
  ];
};

export { contentRender };
